<template>
  <div>
    <page-header :title="$t('bill.origin_res_type_cost')">
      <div slot="res-status-tab" style="position: absolute; right: 0; top: 10px;">
        <bill-config :billShared.sync="billShared" :projectShared.sync="projectShared" :projectSharedShow="projectSharedShow" @update:currency="currencyChange" />
      </div>
    </page-header>
    <page-body>
      <tag-list :id="listId" :billShared="billShared" :projectShared="projectShared" />
    </page-body>
  </div>
</template>

<script>
import BillConfig from '@Bill/sections/BillConfig'
import shareMixin from '@Bill/mixins/share'
import TagList from './components/List'

export default {
  name: 'BillOriginResourceTypeIndex',
  components: {
    TagList,
    BillConfig,
  },
  mixins: [shareMixin],
  data () {
    return {
      listId: 'BillOriginResourceTypeList',
    }
  },
}
</script>
